var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBox",
    { attrs: { direction: "column" } },
    [
      _vm.items && _vm.items.length
        ? _c(
            "ItpBox",
            { attrs: { direction: "column" } },
            _vm._l(_vm.items, function(item) {
              return _c(
                "ItpBox",
                {
                  key: item.id,
                  staticClass:
                    "border rounded rounded-lg p-2 mb-2 overflow-hidden",
                  attrs: { alignItems: "center" }
                },
                [
                  _c("UcFileIcon", {
                    staticClass: "mr-2",
                    attrs: { size: "small", filename: item.file_name }
                  }),
                  _vm._v(" "),
                  _c("ItpLink", {
                    attrs: {
                      text: item.file_name,
                      href: item.download_url,
                      tooltip: item.file_name,
                      downloadFileName: item.file_name,
                      "download-link-only": "",
                      "use-auth": ""
                    }
                  }),
                  _vm._v(" "),
                  !item.locked
                    ? _c(
                        "b-dropdown",
                        {
                          staticClass: "ml-auto mb-auto",
                          attrs: {
                            boundary: "viewport",
                            size: "sm",
                            "toggle-class": "btn-default-borderless",
                            "no-caret": "",
                            variant: "none",
                            dropleft: ""
                          }
                        },
                        [
                          _c("ItpIcon", {
                            staticClass: "mx-1",
                            attrs: { slot: "button-content", fa: "ellipsis-v" },
                            slot: "button-content"
                          }),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item-button",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.evh_5382094220310827_clickPreventStop(
                                    $event,
                                    { item: item }
                                  )
                                }
                              }
                            },
                            [
                              _c("ItpText", {
                                attrs: {
                                  text: _vm._f("pgettext")("Edit", "Command")
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item-button",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.evh_2688566256707306_clickPreventStop(
                                    $event,
                                    { item: item }
                                  )
                                }
                              }
                            },
                            [
                              _c("ItpText", {
                                attrs: {
                                  text: _vm._f("pgettext")("Delete", "Command")
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.parent.isReadOnly
        ? _c("ItpLink", {
            staticClass: "ml-auto",
            attrs: {
              icon: _vm.$config.addIcon,
              text: _vm._f("pgettext")("Upload file...", "Attachments")
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.evh_5962862420439144_clickPreventStop($event, {})
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }